import { useTranslation } from 'react-i18next'

import { Switch } from '@enechain/ecloud-designsystem'

type Props = {
  value: boolean
  onChange: (value: boolean) => void
}

/**
 * テロップ (ticker) の表示/非表示を切り替える Switch。
 * design/settings.html の ecl-switch 相当。
 * onChange で即時 mutation (= 自動保存)。
 */
export const TickerSwitch = ({
  value,
  onChange,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <Switch
        aria-label={t('page:settings.personal.ticker.switchLabel')}
        checked={value}
        id="ticker-toggle"
        onCheckedChange={(details: { checked: boolean }) => {
          onChange(details.checked)
        }}
      />
      <label htmlFor="ticker-toggle" style={{ cursor: 'pointer' }}>
        {t('page:settings.personal.ticker.switchLabel')}
      </label>
    </div>
  )
}
